export const BACKGROUND = "background";
export const PORTRAIT = "portrait";
